import React from "react";
import { Row, Col } from "reactstrap";
import { useAuth } from "../context/AuthContext";
import Loading from "../components/Loading";

const ProfileComponent = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-white">Profile</h1>
        <p className="text-gray-400 mt-1">Your account information</p>
      </div>

      <div className="glass-card p-6">
        <Row className="align-items-center mb-5">
          <Col md={2} className="text-center text-md-left">
            <img
              src={user.picture}
              alt="Profile"
              className="rounded-circle mb-3 mb-md-0"
              style={{
                width: "100px",
                height: "100px",
                border: "3px solid rgba(99, 102, 241, 0.5)",
              }}
            />
          </Col>
          <Col md>
            <h2 className="text-white">{user.name}</h2>
            <p className="lead" style={{ color: "#9ca3af" }}>
              {user.email}
            </p>
          </Col>
        </Row>

        <div className="mt-4">
          <h4 className="text-white mb-3">User Details</h4>
          <pre
            className="p-4 rounded"
            style={{
              background: "rgba(255, 255, 255, 0.05)",
              color: "#e0e0e0",
              overflow: "auto",
            }}
          >
            {JSON.stringify(user, null, 2)}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default ProfileComponent;
